import { useDispatch, useSelector } from "react-redux";
import {
  LAUNCH_VIEWER,
  MODEL_LOADED,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";
import visibility from "../../assets/images/visibility.png";
import visibilityOff from "../../assets/images/visibilityOff.png";
import { useState } from "react";
import DrawingSetModal from "../drawingSets/DrawingSetModal";

const ModelLauncher = () => {
  const { selectedModels, selectedDrawingSet } = useSelector(
    (state) => state.modelReducer,
  );
  const { selectedIcon } = useSelector((state) => state.navigationReducer);

  const [drawingSetModal, setDrawingSetModal] = useState(false);
  const dispatch = useDispatch();

  const hasSelectableModels =
    Array.isArray(selectedModels) &&
    selectedModels.some((model) => model && model.visible !== false);

  const launchViewer = () => {
    if (!hasSelectableModels) {
      return;
    }

    dispatch(
      updateModelState({
        value: true,
        stateName: LAUNCH_VIEWER,
      }),
    );
    dispatch(
      updateModelState({
        value: false,
        stateName: MODEL_LOADED,
      }),
    );
  };

  // const clearModels = () => {
  //    dispatch(
  //      updateModelState({
  //        value: [],
  //        stateName: SELECTED_MODELS,
  //      })
  //    );
  //    dispatch(
  //      updateModelState({
  //        value: false,
  //        stateName: SHEETS_SELECTED,
  //      })
  //    );
  //    dispatch(
  //      updateModelState({
  //        value: null,
  //        stateName: SELECTED_SHEET,
  //      })
  //    );
  //    dispatch(
  //      updateModelState({
  //        value: false,
  //        stateName: LAUNCH_VIEWER,
  //      })
  //    );
  // dispatch(
  //   updateNavigationState({
  //     value: [],
  //     stateName: SELECTED_TREE_ITEMS,
  //   })
  // );
  //       dispatch(
  //      updateModelState({
  //        value: {
  //          process: { processArea: null, projectAssetId: null },
  //          status: null,
  //          discipline: null,
  //        },
  //        stateName: MODEL_FILTER_STATE,
  //      })
  //    );
  //    dispatch(
  //      updateModelState({
  //        value: null,
  //        stateName: SELECTED_DRAWING_SET,
  //      })
  //    );
  // };

  const closeDrawingSetModal = () => {
    setDrawingSetModal(false);
  };

  return (
    <>
      <div style={{ textAlign: "center", paddingTop: "2px", margin: "8px" }}>
        {selectedIcon === "Sheets" ? (
          <>
            <button
              type="button"
              className="btn mwh-btn-primary btn-sm"
              onClick={() => {
                setDrawingSetModal(true);
              }}
              style={{ marginRight: "4px" }}
              disabled={!selectedDrawingSet}
            >
              View Drawing Set Information
            </button>
          </>
        ) : (
          <button
            type="button"
            className="btn btn-success btn-sm"
            onClick={launchViewer}
            style={{ marginRight: "4px" }}
            disabled={!hasSelectableModels}
          >
            Launch Viewer
          </button>
        )}

        {/* <img
          src={visibility}
          alt="View models"
          height={30}
          width={30}
          onClick={launchViewer}
          title="View models"
          style={{ margin: "5px", cursor: "pointer" }}
        />
        <img
          src={visibilityOff}
          alt="Clear models"
          height={30}
          width={30}
          onClick={clearModels}
          title="Clear models"
          style={{ margin: "5px", cursor: "pointer" }}
        /> */}

        {/* <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={clearModels}
          style={{ marginLeft: "4px" }}
          disabled={selectedModels.length === 0}
        >
          Clear Selected Models
        </button> */}
        {/* <button
          type="button"
          className="btn mwh-btn-primary btn-sm"
          onClick={infoModal}
          style={{ marginLeft: "4px" }}
          disabled={selectedItem.length === 0}
        >
          Information management
        </button> */}
      </div>
      {/* <h2>Selected Models:</h2>
      <div style={{ height: "80px", overflowY: "scroll" }}>
        {selectedItem &&
          selectedItem.map((item) => {
            return <p style={{ margin: 0 }}>{item.text}</p>;
          })}
      </div> */}
      <DrawingSetModal
        show={drawingSetModal}
        onHide={closeDrawingSetModal}
        selectedDrawingSet={selectedDrawingSet}
      />
    </>
  );
};

export default ModelLauncher;
